import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { useSeo } from "@/lib/seo";

function Bold({ text }) {
  const parts = text.split(/\*\*(.+?)\*\*/g);
  return parts.map((p, i) => (i % 2 ? <strong key={i}>{p}</strong> : p));
}

export function renderMarkdown(md) {
  const out = [];
  let list = [];
  const flush = () => { if (list.length) { out.push(<ol key={`ol${out.length}`} style={{ lineHeight: 1.7, paddingLeft: 20 }}>{list}</ol>); list = []; } };
  md.split("\n").forEach((line, i) => {
    const l = line.trimEnd();
    if (l.startsWith("# ")) { flush(); out.push(<h1 key={i}><Bold text={l.slice(2)} /></h1>); }
    else if (l.startsWith("## ")) { flush(); out.push(<h2 key={i} style={{ fontSize: 22 }}><Bold text={l.slice(3)} /></h2>); }
    else if (/^\d+\.\s/.test(l)) list.push(<li key={i}><Bold text={l.replace(/^\d+\.\s/, "")} /></li>);
    else if (l === "") flush();
    else { flush(); out.push(<p key={i}><Bold text={l} /></p>); }
  });
  flush();
  return out;
}

export function Terms({ which }) {
  useSeo({ title: which === "tester" ? "Tester terms" : "Client terms", description: which === "tester" ? "Terms for testers taking paid 99tests sessions." : "Terms for clients buying 99tests real-device testing packages.", path: which === "tester" ? "/tester-terms" : "/terms", noindex: true });
  const { data, isLoading } = useQuery({ queryKey: ["terms", which], queryFn: () => api.terms(which) });
  return (
    <main className="app-main"><div className="wrap narrow" data-testid={`legal-${which}-terms`}>
      {isLoading ? <p>Loading…</p> : renderMarkdown(data?.markdown || "")}
    </div></main>
  );
}

export function Privacy() {
  useSeo({ title: "Privacy", description: "What 99tests collects from clients and testers, how builds and media are stored, and how to request deletion.", path: "/privacy", noindex: true });
  return (
    <main className="app-main"><div className="wrap narrow" data-testid="legal-privacy">
      <h1>Privacy</h1>
      <p>We collect only what we need to run tests and pay testers: client email + billing details (via Stripe), tester name, city, phone, declared devices and UPI ID, and the findings + media created during sessions.</p>
      <p>Builds are shared by link only to assigned testers and are not stored beyond the job. Media is stored privately and linked only from the client report. Tester PII is never logged. We keep anonymised aggregate statistics.</p>
      <p>Testers can unsubscribe at any time; contact <a href="mailto:hello@99tests.com">hello@99tests.com</a> for data requests.</p>
    </div></main>
  );
}
